export const isIOSLikeDevice = () =>
  /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

  // Enhanced device detection for all device types
export const detectDeviceCapabilities = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const iosLike = isIOSLikeDevice();

    // Comprehensive device detection
    const deviceInfo = {
      // Mobile phones
      isAndroid: /android/i.test(userAgent),
      isIOS: iosLike && !window.MSStream,
      isWindowsPhone: /windows phone/i.test(userAgent),

      // Tablets
      isIPad: (/iPad/.test(userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)) && !window.MSStream,
      isAndroidTablet: /android/i.test(userAgent) && !/mobile/i.test(userAgent),

      // Desktop browsers with potential motion support
      isChrome: /chrome/i.test(userAgent) && !/edge/i.test(userAgent),
      isFirefox: /firefox/i.test(userAgent),
      isSafari: /safari/i.test(userAgent) && !/chrome/i.test(userAgent),
      isEdge: /edge/i.test(userAgent),

      // iOS browsers all run on WKWebView; detect specifically because Chrome/Firefox/Edge
      // on iOS have stricter sensor permission behavior (especially inside cross-origin iframes).
      isIOSChrome: /CriOS\//.test(userAgent),
      isIOSFirefox: /FxiOS\//.test(userAgent),
      isIOSEdge: /EdgiOS\//.test(userAgent),

      // Specific devices
      isSamsung: /samsung/i.test(userAgent),
      isHuawei: /huawei/i.test(userAgent),
      isXiaomi: /xiaomi/i.test(userAgent),
      isOppo: /oppo/i.test(userAgent),
      isVivo: /vivo/i.test(userAgent),
      isOnePlus: /oneplus/i.test(userAgent),

      // Feature detection
      hasDeviceMotion: 'DeviceMotionEvent' in window,
      canRequestMotionPermission:
        typeof window.DeviceMotionEvent !== "undefined" &&
        typeof window.DeviceMotionEvent.requestPermission === "function",
      hasDeviceOrientation: 'DeviceOrientationEvent' in window,
      hasTouchSupport: 'ontouchstart' in window || navigator.maxTouchPoints > 0,
      hasAccelerometer: 'DeviceMotionEvent' in window,

      // Screen properties
      screenWidth: window.screen.width,
      screenHeight: window.screen.height,
      pixelRatio: window.devicePixelRatio || 1
    };

    // Determine if device likely supports motion
    deviceInfo.isMobile = deviceInfo.isAndroid || deviceInfo.isIOS || deviceInfo.isWindowsPhone;
    deviceInfo.isTablet = deviceInfo.isIPad || deviceInfo.isAndroidTablet;
    deviceInfo.isTouchDevice = deviceInfo.isMobile || deviceInfo.isTablet || deviceInfo.hasTouchSupport;
    deviceInfo.supportsMotion = deviceInfo.hasDeviceMotion && (deviceInfo.isMobile || deviceInfo.isTablet);

    return deviceInfo;
  };
